"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateChildDetailsDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const validate_date_1 = require("../../../../../service-lib/src/lib/utils/validate-date");
class CreateChildDetailsDto {
}
exports.CreateChildDetailsDto = CreateChildDetailsDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Contact Details ID should be a number" }),
    tslib_1.__metadata("design:type", Number)
], CreateChildDetailsDto.prototype, "contactDetailsId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Child name should be a string" }),
    (0, class_validator_1.MaxLength)(100, { message: "Child name must not exceed 100 characters" }),
    tslib_1.__metadata("design:type", String)
], CreateChildDetailsDto.prototype, "childName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Child date of birth should be a date." }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    (0, class_validator_1.Matches)(/^\d{4}-\d{2}-\d{2}$/, {
        message: "Child date of birth must be in the format YYYY-MM-DD.",
    }),
    (0, class_transformer_1.Transform)(({ value }) => (0, validate_date_1.validatePastDate)(value, "Child date of birth")),
    tslib_1.__metadata("design:type", String)
], CreateChildDetailsDto.prototype, "childDob", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Child gender should be a number" }),
    tslib_1.__metadata("design:type", Number)
], CreateChildDetailsDto.prototype, "childGender", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateChildDetailsDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateChildDetailsDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], CreateChildDetailsDto.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], CreateChildDetailsDto.prototype, "updatedAt", void 0);
